export default "__VITE_ASSET__3SpgdJyh__"